// Constants for different requests for current reducer
export default {
  users: 'USERS',
  user: 'USER',
  createUser: 'CREATE_USER',
  updateUser: 'UPDATE_USER',
};
